import { render, staticRenderFns } from "./Equipment.vue?vue&type=template&id=28e32455&scoped=true"
import script from "./Equipment.vue?vue&type=script&lang=js"
export * from "./Equipment.vue?vue&type=script&lang=js"
import style0 from "./Equipment.vue?vue&type=style&index=0&id=28e32455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e32455",
  null
  
)

export default component.exports